import { Image, Text } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import { INTERCOM_LAUNCHER_PROPS } from 'features/Intercom';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Illustration from './assets/Notepad@2x.png';
import locales from './locales';

const ContactSupport = asBentoPage(({ Layout, onPrev }) => (
  <Layout data-testid="contact-support" nav={<OBNavigation onPrev={onPrev} />}>
    <Image
      boxSize="180px"
      marginBottom="space-16"
      marginX="auto"
      src={Illustration}
    />

    <Heading marginBottom="space-16" size="lg">
      {locales.title}
    </Heading>

    <Text marginBottom="space-32" variant="primary">
      {locales.description}
    </Text>

    <Button {...INTERCOM_LAUNCHER_PROPS}>{locales.cta}</Button>
  </Layout>
));

export default ContactSupport;
